<template>
    <v-container>
        <v-card class="pa-4 pt-0">
            <v-row justify="start">
                <v-breadcrumbs :items="crump" divider=">"></v-breadcrumbs>
            </v-row>
            <v-row>
                <v-col cols="6" xs="12">
                    <v-card-text>
                        <span class="headline font-weight-light">Recht bearbeiten "{{item.name}}"</span>
                    </v-card-text>
                </v-col>
                <v-col cols="6" xs="12" style="text-align: right">
                    <v-btn @click="close" icon color="red">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6" class="py-0">
                    <v-text-field
                            label="Name"
                            clearable
                            height="56"
                            outlined
                            v-model="item.name"
                            dense
                    ></v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                    <v-text-field
                            label="Rechte Guid"
                            clearable
                            height="56"
                            outlined
                            v-model="item.guidRight"
                            dense
                    ></v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                    <v-select
                            outlined
                            v-model="item.groupName"
                            :items="groupNames"
                            item-text="text"
                            item-value="value"
                            label="Gruppe"
                    >
                    </v-select>
                </v-col>
                <v-col cols="6" class="py-0">
                    <v-checkbox outlined v-model="item.allowed" class="mx-2" label="Standard aktiviert"></v-checkbox>
                </v-col>
                <v-col cols="6" class="py-0">
                    <v-text-field
                            label="Beschreibung"
                            clearable
                            height="56"
                            outlined
                            v-model="item.comment"
                            dense
                    ></v-text-field>
                </v-col>
                <v-col cols="12" class="text-right">
                    <v-btn @click="saveItem()">Speichern</v-btn>
                </v-col>
            </v-row>

        </v-card>
    </v-container>
</template>

<script>
    import Vue from "vue";

    export default {
        name: 'RightDefault',
        data() {
            return {
                groupNames: [{
                    value: 'NETWORK',
                    text: 'Netzwerk'
                },{
                    value: 'COMPONENT',
                    text: 'Komponente'
                },{
                    value: 'DASHBOARD',
                    text: 'Dashboard'
                }],
                item: {
                    name: 'Benutzer darf ...',
                    guidRight: 'RIGHT_',
                    guidParent: 'DEFAULT_ALL'
                }
            }
        },
        methods: {
            saveItem: function () {

                if (this.guid === 'NewItem') {
                    console.log('createItem', this.item)
                    Vue.prototype.$apiRight.createRight(this.item, this.onGetData)
                } else {
                    console.log('saveItem', this.item)
                    Vue.prototype.$apiRight.updateRight(this.item, this.onGetData)
                }

            },
            myMethod: function () {
            },
            close: function () {
                window.history.back();
            },
            onGetData: function (data) {
                console.log('right', data)
                if (data.length > 0) {
                    this.item = data[0]
                    this.guid = this.item.guid
                }
            },
            reload: function () {
                var reqData = {}
                if (this.guid != null) {
                    reqData.guid = this.guid
                }
                Vue.prototype.$apiRight.loadRights(reqData, this.onGetData)
            }
        },
        mounted() {
            this.guid = this.$route.params.guid
            this.reload()
        }
    }
</script>

<style scoped>

</style>
